import { isMobile } from "react-device-detect";
import { trackShare } from "./analytics";
import { calcRarity } from "./calcRarity";
import { rarityScheme } from "./rarityScheme";
import useGameStore from "../store/GameStore";
import usePersistentStore from "../store/PersistentStore";
import { getDateKeyForLevel, gridLevelNumber } from "./gridLevels";
import { getLocale, t } from "../../i18n/runtime";
import { absoluteUrl, localePath } from "../../i18n/config";

// "https://pokegrid.net/" for today's English grid,
// "https://pokegrid.net/fr/2024-01-05" for a French archive grid
function shareUrl(levelNumber, isArchive) {
  const path = isArchive ? `/${getDateKeyForLevel(levelNumber)}` : "/";

  return absoluteUrl(localePath(getLocale(), path));
}

function getShareState() {
  const state = useGameStore.getState();
  const persistentState = usePersistentStore.getState();

  return {
    levelNumber: state.levelNumber,
    gameName: state.shareGameName,
    grid: state.grid,
    globalStats: state.globalStats,
    score: persistentState.score,
    correctGuesses: persistentState.correctGuesses,
    cardMode: persistentState.cardMode,
    isArchive: state.levelNumber !== gridLevelNumber,
  };
}

export function handleTweet() {
  const shareState = getShareState();

  const copy = tweetCopy(shareState);

  return copy;
}

export async function handleShare() {
  const shareState = getShareState();
  const copy = shareCopy(shareState);

  const levelNumber = shareState.levelNumber;

  share({ copy, levelNumber });
}

export function shareCopy({
  levelNumber,
  gameName,
  grid,
  globalStats,
  score,
  correctGuesses,
  cardMode,
  isArchive,
}) {
  const emojiText = emojiGrid(grid, correctGuesses, globalStats, cardMode);
  const scoreText = score == 9 ? `${t("share.perfect")}\n` : "";
  const archiveText = isArchive ? `${t("share.archive")}\n` : "";
  const rarity = calcRarity(correctGuesses, globalStats);

  const copy = `${gameName} ${levelNumber} - ${score}/9
${archiveText}
${scoreText}${emojiText}${t("share.rarity", { rarity })}

${shareUrl(levelNumber, isArchive)}`;

  console.log(copy);

  return copy;
}

export function tweetCopy({
  levelNumber,
  gameName,
  grid,
  globalStats,
  score,
  correctGuesses,
  cardMode,
  isArchive,
}) {
  const emojiText = emojiGrid(grid, correctGuesses, globalStats, cardMode);
  const scoreText = score == 9 ? `${t("share.perfect")}\n` : "";
  const archiveText = isArchive ? `${t("share.archive")}\n` : "";
  const rarity = calcRarity(correctGuesses, globalStats);
  // "pokegrid.net" or "pokegrid.net/fr"
  const url = `pokegrid.net${localePath(getLocale(), "/")}`.replace(/\/$/, "");

  const copy = `PokeGrid #${levelNumber} - ${score}/9
${archiveText}
${scoreText}${emojiText}${t("share.rarity", { rarity })}

${t("share.playAt", { url })}`;

  return copy;
}

export async function share({ copy, levelNumber }) {
  if ("share" in navigator && isMobile) {
    const shareData = {
      text: copy,
    };

    try {
      await navigator.share(shareData);
      trackShare({ method: "Mobile", itemId: levelNumber });
    } catch (err) {
      console.log(err);
    }
  } else {
    try {
      updateClipboard(copy);
      trackShare({ method: "Copy", itemId: levelNumber });
    } catch (err) {
      console.log(err);
    }
  }
}

function emojiGrid(grid, correctGuesses, globalStats, cardMode) {
  let text = "　 ";

  grid.hItems.forEach((hItem) => {
    text += hItem.emoji;
  });
  text += "\n";

  correctGuesses.forEach((row, rowIndex) => {
    const vItem = grid.vItems[rowIndex];
    text += vItem.emoji;

    row.forEach((col, colIndex) => {
      if (col == null) {
        text += "⬜";
      } else if (!cardMode) {
        text += "🟩";
      } else {
        const correctAnswersPlayerMap =
          globalStats?.correctAnswersPlayerMap[rowIndex][colIndex];
        const correctPokemonId = col;
        const pct = correctAnswersPlayerMap
          ? (correctAnswersPlayerMap[correctPokemonId] /
              globalStats.completed) *
            100
          : 0.1;

        const scheme = rarityScheme(pct);

        text += scheme.emojiSquare;
      }
    });
    text += "\n";
  });

  return text;
}

function updateClipboard(newClip) {
  return navigator.clipboard.writeText(newClip);
}
